// Presence heartbeat resiliente a throttling de aba em segundo plano.
//
// O setTimeout de uma aba oculta é throttled pelo navegador -- no Chrome, chega a 1x/min
// depois de alguns minutos de inatividade. É isso que apaga o agente da fila de voz mesmo
// com PRESENCE_DURATION alargado (roadmap 13-ux-da-chamada, P-01/P-02): heartbeat de 20s
// que na prática vira 60s some da janela.
//
// Um Web Worker roda numa thread separada da página, livre desse throttling -- por isso o
// heartbeat passa a rodar nele quando disponível, com o setTimeout de sempre como fallback
// (SSR, ambiente sem Worker, ou o próprio construtor falhando). Nunca fica sem heartbeat
// nenhum: o pior caso é o comportamento de hoje, não ausência de presença.

function workerScript(intervalMs) {
  return `setInterval(() => postMessage('tick'), ${intervalMs});`;
}

function supportsWorker() {
  return (
    typeof Worker !== 'undefined' &&
    typeof Blob !== 'undefined' &&
    typeof URL !== 'undefined' &&
    typeof URL.createObjectURL === 'function'
  );
}

class PresenceHeartbeat {
  constructor(callback, intervalMs) {
    this.callback = callback;
    this.intervalMs = intervalMs;
    this.worker = null;
    this.timeoutId = null;

    this.onVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        this.callback();
      }
    };
  }

  start() {
    if (supportsWorker()) {
      this.startWorker();
    } else {
      this.startFallbackTimer();
    }

    if (typeof document !== 'undefined') {
      document.addEventListener('visibilitychange', this.onVisibilityChange);
    }
  }

  startWorker() {
    try {
      const blob = new Blob([workerScript(this.intervalMs)], {
        type: 'application/javascript',
      });
      const url = URL.createObjectURL(blob);
      this.worker = new Worker(url);
      this.worker.onmessage = () => this.callback();
    } catch (error) {
      this.startFallbackTimer();
    }
  }

  startFallbackTimer() {
    this.timeoutId = setTimeout(() => {
      this.callback();
      this.startFallbackTimer();
    }, this.intervalMs);
  }

  stop() {
    if (this.worker) {
      this.worker.terminate();
      this.worker = null;
    }
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
    if (typeof document !== 'undefined') {
      document.removeEventListener('visibilitychange', this.onVisibilityChange);
    }
  }
}

export default PresenceHeartbeat;
